module.exports = __webpack_public_path__ + "static/img/lose.c9fd7c66.svg";